import { IconDefinition } from "./types";

const search: IconDefinition = {
  iconName: "search",
  width: 16,
  height: 16,
  svgPathData:
    "M.9 6.6c0 3.2 2.6 5.7 5.7 5.7s5.7-2.6 5.7-5.7S9.8.9 6.6.9.9 3.4.9 6.6m10 4.3l3.9 3.9",
  iconType: "stroke",
};

export { search };
